import {MOKA_SERVICE_URL, API_URL} from 'api/constants'
export const ADD_SUBSCRIPTION = `${API_URL}/v1/feature/add_subscription`
export const GET_LOYALTY = (businessId) => `${MOKA_SERVICE_URL}/loyalty/v1/programs`
export const CREATE_LOYALTY = (businessId) => `${MOKA_SERVICE_URL}/loyalty/v1/programs`
export const EDIT_LOYALTY = (businessId) => `${MOKA_SERVICE_URL}/loyalty/v1/programs`
export const RESET_LOYALTY = (businessId) => `${MOKA_SERVICE_URL}/loyalty/v1/programs/reset`
export const REACTIVATE_LOYALTY = (businessId) => `${MOKA_SERVICE_URL}/loyalty/v1/programs/reactivate`
export const DEACTIVATE_LOYALTY = (businessId) => `${MOKA_SERVICE_URL}/loyalty/v1/programs/deactivate`



// WEBPACK FOOTER //
// ./app/api/customers/loyalty/constants.js